import { createDeepEqualSelector } from "../utils";

import type { RootState } from "../store";

const selectRecipients = (state: RootState) => state.recipients.byId;

// Hidden recipients (e.g. unsaved recipients created during ACH file import)
// may be loaded into the shared store so that read-only views like Payment
// Activity and Approvals can resolve them by id. They must NOT surface in
// user-facing recipient pickers/lists, so the list-facing selector excludes
// them. Id-based lookups (selectOneRecipient) and the full lookup pool
// (selectAllRecipients) intentionally keep hidden recipients so those views
// can still resolve them. See PRO-1633.
export const selectSortedRecipients = createDeepEqualSelector(
  selectRecipients,
  (byId) =>
    Object.values(byId)
      .filter((recipient) => !recipient.hidden)
      .sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectOneRecipient = createDeepEqualSelector(
  [selectRecipients, (_, recipientId?: API.RecipientId) => recipientId],
  (byId, recipientId): API.Recipient | undefined => {
    return recipientId ? byId[recipientId] : undefined;
  },
);

export const selectAllRecipients = createDeepEqualSelector(
  selectRecipients,
  (byId) => Object.values(byId),
);
